import { render, staticRenderFns } from "./ProcessListActions.vue?vue&type=template&id=c1370890&"
import script from "./ProcessListActions.vue?vue&type=script&lang=js&"
export * from "./ProcessListActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports